import {
  UPDATE_NOTIFICATION,
  RESET_NOTIFICATION,
  SET_NOTIFICATION
} from './notificationActions';

// Function to get notification length from local storage
const getStoredNotificationLength = () => {
  const storedLength = localStorage.getItem('notificationLength');
  return storedLength ? parseInt(storedLength, 10) : 0;
};

// Initial state with notification length loaded from local storage
const initialState = {
  notificationLength: getStoredNotificationLength(), // Load length from local storage
};

// Reducer function to manage the notification length state
const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_NOTIFICATION:
      const length = action.payload;
      localStorage.setItem('notificationLength', length);
      return {
        ...state,
        notificationLength: length,
      };
      
    case UPDATE_NOTIFICATION:
      const newLength = action.payload; // Fix typo here
      localStorage.setItem('notificationLength', newLength);
      return {
        ...state,
        notificationLength: newLength, // Update the length
      };

    case RESET_NOTIFICATION:
      localStorage.removeItem('notificationLength'); // Clear length from local storage
      return {
        ...state,
        notificationLength: 0, // Reset length to 0
      };

    default:
      return state;
  }
};

export default notificationReducer;
